export const UserTools = {
  validateIntLegalNumber: (value: string | number | boolean): boolean => {
    const legalNumber = value.toString().replace(/\s/g, '');
    return /^[0-9a-z]{5,14}$/gim.test(legalNumber);
  },
};
